export const statusToUnlock = ['Bloqueado', 'Solicitou desbloqueio'];
